/*
 * BeeCaramulo Apiturismo - v0.1.0
 * Author: truebond.pt
 * 
 * Section: To Visit
 */

import { Container, Row } from 'react-bootstrap'

const ToVisit = (props) => {
    const {tovisit} = props;

    return(
        <Container>
            <Row>
                <p className="text-center mb-4">
                    {tovisit.text1}
                </p>
                <p className="text-center">
                    {tovisit.text2}
                </p>
            </Row>
        </Container>
    );
}

export default ToVisit;